export const comments_5480353 = {"data":{"data":[],"links":{}}}